import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import ReactHtmlParser from 'html-react-parser'
import { size, map } from 'lodash'

import style from './style'

/**
 * A simple list with options of icons off to the right and to either show a subgroup or linking somewhere
 */
class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeItem: null
    }
    this.renderItems = this.renderItems.bind(this)
  }

  render() {
    const {
      classes,
      items,
      className,
      isNoTopBorder,
      isNoBorders,
      isReportStyle
    } = this.props
    const { base, noTopBorder, noBorders } = classes

    return (
      <div
        className={`${base} ${className} ${isNoTopBorder ? noTopBorder : ''} ${isNoBorders ? noBorders : ''
          } ${isReportStyle ? classes.reportStyle : ''}
        }`}
      >
        {this.renderItems(items, this.props)}
      </div>
    )
  }

  componentDidMount() {
    // If mobile and only a 1 list item then keep it open
    const isOpenAccordian =
      this.props.isMobile && size(this.props.items) === 1
    const key = Object.getOwnPropertyNames(this.props.items)[0]
    if (isOpenAccordian) this.setState({ activeItem: key })
  }

  renderItems(items, props) {
    const {
      action,
      classes,
      isMobile,
      isBoldOnMobile,
      isCollapsedDark,
      isNotSpacer
    } = props
    const { activeItem } = this.state
    return (
      <ul>
        {map(items, (item, index) => {
          const {
            subTitle,
            icon,
            accordianContent,
            isShowAccordianOnMobile,
            shouldActiveHighlight
          } = item

          const _meta = item._meta || {}
          const route = _meta.route || item.route
          const title = _meta.title || item.title
          const onClick = _meta.onClick || item.onClick

          const showAccordian = accordianContent && activeItem === index

          const handleClick = (e, index) => {
            if (onClick) onClick()
            if (route) {
              const payload = { route, index }
              if (action) action(payload)
            }

            e.stopPropagation()
            this.setState(prevState => {
              if (isMobile && !isShowAccordianOnMobile) return
              if (prevState.activeItem !== index) {
                return {
                  activeItem: index
                }
              }
              return {
                activeItem: false
              }
            })
          }

          let textClassName = ''
          if (icon && icon.defaultColor) {
            textClassName = `${textClassName} ${classes.defaultColor}`
          }
          if (icon && isMobile && !icon.noMobilePadding) {
            textClassName = `${textClassName} ${classes.paddedIcon}`
          }
          if (icon && icon.isPaddedIcon) {
            textClassName = `${textClassName} ${classes.paddedIcon}`
          }

          return (
            <li
              className={`${isCollapsedDark && showAccordian ? classes.collapsedDark : ''
                }`}
              key={index}
              onClick={e => handleClick(e, index)}
            >
              <span>
                <span
                  className={
                    shouldActiveHighlight && showAccordian ? classes.active : ''
                  }
                >
                  {showAccordian && !isNotSpacer ? (
                    <div className={classes.spacer} />
                  ) : null}
                  <span
                    className={`${classes.title} ${isBoldOnMobile ? classes.boldOnMobile : ''
                      }`}
                  >
                    {ReactHtmlParser(title || _meta.title)}
                  </span>
                  {subTitle && (
                    <Fragment>
                      <br />
                      <span className={classes.subTitle}>{subTitle}</span>
                    </Fragment>
                  )}
                </span>
                {icon ? (
                  <span>
                    {icon.src ? (
                      <img
                        className={showAccordian ? 'flip' : ''}
                        src={icon.src}
                      />
                    ) : (
                      <span className={textClassName}>
                        {' '}
                        {ReactHtmlParser(icon.text)}
                      </span>
                    )}
                  </span>
                ) : null}
              </span>
              {(showAccordian && !isMobile) ||
                (showAccordian && isShowAccordianOnMobile) ? (
                <div className={classes.accordian}>
                  {ReactHtmlParser(accordianContent)}
                </div>
              ) : null}
            </li>
          )
        })}
      </ul>
    )
  }
}

const styleAndTheme = () => style

List.propTypes = {
  classes: PropTypes.object,
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  isNoTopBorder: PropTypes.bool,
  isNoBorders: PropTypes.bool,
  isReportStyle: PropTypes.bool,
  isMobile: PropTypes.bool
}
export default injectSheet(styleAndTheme)(List)
